export default [

  {
    path: '/verified/:id',
    name: 'index',
    component: () => import('@/views/verified/index'),
    meta: {
      title: ''
    }
  }
]
